import { INTAKE_INTRO_ID } from './intake-form/intake-copy';

const TABBABLE_SELECTOR =
  'a[href], button, input, select, textarea, [tabindex]';

export function isRendered(el: HTMLElement): boolean {
  if (el.getAttribute('aria-hidden') === 'true') return false;
  if (typeof el.checkVisibility === 'function') {
    // MUI Checkbox uses opacity: 0 on the native input; keep it tabbable.
    return el.checkVisibility({
      checkOpacity: false,
      checkVisibilityCSS: true,
    });
  }
  // Without checkVisibility, an ancestor's display:none still leaves no client rects.
  return (
    el.getClientRects().length > 0 &&
    window.getComputedStyle(el).visibility !== 'hidden'
  );
}

/** Tab stops inside `dialog` in DOM order, without hidden or disabled controls. */
export function getDialogTabbables(dialog: HTMLElement): HTMLElement[] {
  return Array.from(
    dialog.querySelectorAll<HTMLElement>(TABBABLE_SELECTOR)
  ).filter(
    el =>
      el.tabIndex >= 0 &&
      !el.matches(':disabled') &&
      !el.closest('[inert]') &&
      isRendered(el)
  );
}

/** document.activeElement is the shadow host when focus is inside the widget. */
export function getActiveElementIn(node: Node): Element | null {
  const root = node.getRootNode();
  if (root instanceof ShadowRoot && root.activeElement)
    return root.activeElement;
  return document.activeElement;
}

/** The intake intro sentence, looked up in the dialog's own root (document ids do not reach a shadow root). */
export function getIntakeIntro(dialog: HTMLElement): HTMLElement | null {
  const root = dialog.getRootNode();
  if (root instanceof ShadowRoot || root instanceof Document) {
    return root.getElementById(INTAKE_INTRO_ID);
  }
  return dialog.querySelector<HTMLElement>(`#${INTAKE_INTRO_ID}`);
}
